import { CertDemeterDataResponseDTO, CertDemeterResponseDTO, createCertDemeterDTO, GetAllCertificatesFiltersDTO, updateCertDemeterDTO } from "./dto";
import { DemeterServiceImpl } from "./serviceImpl";

export interface DemeterService {
    GetAllDemeter(filters: GetAllCertificatesFiltersDTO): Promise<CertDemeterResponseDTO>
    CreateDemeter(data: createCertDemeterDTO): Promise<void>
    UpdateDemeter(data: updateCertDemeterDTO, id: string): Promise<void>
}

export function NewDemeterService(): DemeterService {
    return new DemeterServiceImpl()
}